// covered-by: frontends/carrie/src/ask-v2/__tests__/paths.test.ts
/**
 * V2 URL shapes. Same prefixes as V1 Ask Puntt so in-place app.puntt.ai
 * links keep working. `src/ask-v2/**` must not import `src/routes/ask-puntt`;
 * reused V1 settings/ROI views may lazy-load ask-puntt widgets via
 * `routes/settings/routes/lazyAskPunttSettingsWidgets.tsx` only.
 */

export const ASK_V2_HOME_PATH = "/" as const;
export const ASK_V2_ASK_HOME_PATH = "/ask-puntt" as const;
export const ASK_V2_CHATS_PATH = "/ask-puntt/chats" as const;
export const ASK_V2_CHAT_PATH = "/ask-puntt/$chatId" as const;
export const ASK_V2_PROJECTS_PATH = "/ask-puntt/projects" as const;
export const ASK_V2_PROJECT_PATH = "/ask-puntt/projects/$projectId" as const;
export const ASK_V2_PROJECT_REVIEW_PATH =
  "/ask-puntt/projects/$projectId/reviews/$reviewId" as const;
export const ASK_V2_PROJECT_REVIEW_COMMENT_PATH =
  "/ask-puntt/projects/$projectId/reviews/$reviewId/comments/$commentId" as const;
export const ASK_V2_CHAT_REVIEW_PATH =
  "/ask-puntt/$chatId/reviews/$reviewId" as const;
export const ASK_V2_CHAT_REVIEW_COMMENT_PATH =
  "/ask-puntt/$chatId/reviews/$reviewId/comments/$commentId" as const;

export const ASK_V2_SETTINGS_PATH = "/settings" as const;
export const ASK_V2_ENTERPRISE_SETTINGS_PATH = "/enterprise-settings" as const;
export const ASK_V2_KNOWLEDGE_SETTINGS_PATH = "/knowledge-settings" as const;
export const ASK_V2_KNOWLEDGE_DATABASE_PATH =
  "/settings/knowledge-database" as const;
export const ASK_V2_INTEGRATION_SETTINGS_PATH =
  "/integration-settings" as const;
export const ASK_V2_NOTIFICATIONS_SETTINGS_PATH =
  "/notifications-settings" as const;
export const ASK_V2_USERS_PATH = "/users" as const;
export const ASK_V2_ARCHIVED_USERS_PATH = "/archived-users" as const;
export const ASK_V2_ROI_PATH = "/roi" as const;

/** Canonical landing search for Knowledge Database links. */
export const ASK_V2_KNOWLEDGE_DATABASE_SEARCH = {
  tab: "sources",
  status: "active",
} as const;

export function askV2ChatPath(chatId: string): string {
  return `/ask-puntt/${chatId}`;
}

export function askV2ProjectPath(projectId: string): string {
  return `/ask-puntt/projects/${projectId}`;
}

export function buildAskV2ProjectReviewPath(
  projectId: string,
  reviewId: string,
  commentId?: string,
) {
  if (commentId) {
    return {
      to: ASK_V2_PROJECT_REVIEW_COMMENT_PATH,
      params: { projectId, reviewId, commentId },
    } as const;
  }
  return {
    to: ASK_V2_PROJECT_REVIEW_PATH,
    params: { projectId, reviewId },
  } as const;
}

export function buildAskV2ChatReviewPath(
  chatId: string,
  reviewId: string,
  commentId?: string,
) {
  if (commentId) {
    return {
      to: ASK_V2_CHAT_REVIEW_COMMENT_PATH,
      params: { chatId, reviewId, commentId },
    } as const;
  }
  return {
    to: ASK_V2_CHAT_REVIEW_PATH,
    params: { chatId, reviewId },
  } as const;
}
